import { getAPI, postAPI, deleteAPI, patchAPI } from "utils/http";
import { apis } from "config/urls";

export async function fetchExternalPermissions({ token }) {
  const response = await getAPI(apis.externalPermissionsAPI(), { page: 0, size: 1000 }, token);
  const { data: res, status } = response;
  if (status === 200) {
    return res.data.items;
  }
  throw new Error("Failed to fetch external permissions", { cause: response });
}

export async function getPermissionByName({ token, permissionName }) {
  // set roleName to undefined to  fetch by permissionName
  const roleName = undefined;

  const response = await getAPI(
    apis.externalPermissionsAPI(roleName, permissionName),
    {},
    token
  );
  const { data: res, status } = response;
  if (status === 200) {
    return res.data.items[0];
  }
  throw new Error("Failed to fetch permission by name", { cause: response });
}

export async function deletePermissionById({ token, permissionId }) {
  const response = await deleteAPI(
    apis.deleteExternalPermissionsAPI + `/${permissionId}`,
    {},
    token
  );
  const { data: res, status } = response;
  if (status === 200) {
    return res;
  }
  throw new Error("Failed to delete permission", { cause: response });
}

export async function createExternalPermission({ token, permission }) {
  const payload = {
    scope: permission.scope,
    scopeDesc: permission.scopeDesc,
    roleNames: permission.roleNames,
  };
  const response = await postAPI(
    apis.createExternalPermissionsAPI,
    payload,
    token
  );
  const { data: res, status } = response;
  if (status === 201) {
    return res;
  }
  throw new Error("Failed to create permission", { cause: response });
}

export async function getPermissionById({ token, permissionId }) {
  const response = await getAPI(
    apis.getExternalPermissionsAPI + `/${permissionId}`,
    {},
    token
  );
  const { data: res, status } = response;
  if (status === 200) {
    return res;
  }
  throw new Error("Failed to fetch permission by id", { cause: response });
}

export async function updateExternalPermission({ token, permission }) {
  const payload = {
    scope: permission.scope,
    scopeDesc: permission.scopeDesc,
    roleNames: permission.roleNames,
  };
  const response = await patchAPI(
    `${apis.updateExternalPermissionsAPI}/${permission.id}`,
    payload,
    token
  );
  const { data: res, status } = response;
  if (status === 200) {
    return res;
  }
  throw new Error("Failed to update permission", { cause: response });
}
